import { Consents } from "@obg/ngx.common";
import { Legal, MarketingOffers, Subscriptions } from "@obg/ngx.core";

import {
	AffiliateMetadata,
	PersonDetails,
	ProductMetadata,
	RegistrationFormFlow,
	UserIdentity,
} from "../registration.model";

export interface RegistrationWithPersonalNumberState {
	personalNumber?: string;
	personalNumberInformationLevel?: PersonalNumberInformationLevel;
	submittedPersonalNumber?: string;
	submittedPersonalNumberInformationLevel?: PersonalNumberInformationLevel;
	registrationDetails?: RegistrationWithPersonalNumberSimplePayload | RegistrationWithPersonalNumberCompletePayload;
	token?: string;
	hashedEmail?: string;
}

export enum PersonalNumberInformationLevel {
	NoData = "NoData",
	Partial = "Partial",
	Full = "Full",
}

export interface PersonalNumberVerificationResponse {
	informationLevel: PersonalNumberInformationLevel;
}

export interface PersonalNumberVerificationSuccessResponse extends PersonalNumberVerificationResponse {
	personalNumber: string;
}

export interface RegistrationWithPersonalNumberRequestBase {
	flow: RegistrationFormFlow;
	language: string;
	timeZone: string;
	iovationBlackBox?: string;
	fraudToken?: string;
	credential: UserIdentity;
	subscriptions: Subscriptions;
	legal: Legal;
	affiliateMetadata: AffiliateMetadata[];
	consents?: Partial<Consents>;
	productMetadata?: ProductMetadata;
}

export interface RegistrationWithPersonalNumberSimpleRequest extends RegistrationWithPersonalNumberRequestBase {
	person: PersonalNumber;
}

export interface RegistrationWithPersonalNumberCompleteRequest extends RegistrationWithPersonalNumberRequestBase {
	person: PersonWithPersonalNumber;
	address: AddressWithoutCountry;
}

export interface RegistrationWithPersonalNumberSimplePayload {
	credential: UserIdentity;
	phoneNumber: string;
	phoneExtension: string;
	marketingOffers: MarketingOffers;
	legal: Legal;
	consents?: Partial<Consents>;
	iovationBlackBox?: string;
	fraudToken?: string;
}

export interface RegistrationWithPersonalNumberCompletePayload extends RegistrationWithPersonalNumberSimplePayload {
	person: PersonDetails;
	address: AddressWithoutCountry;
}

export interface PersonalNumber {
	personalNumber: string;
}

export interface AddressWithoutCountry {
	street: string;
	zipCode: string;
	city: string;
}

export interface PersonWithPersonalNumber extends PersonDetails, PersonalNumber {}
